import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Container,
} from '@material-ui/core/';

import { mediaHelper } from '../../utils';

const propTypes = {
  renderTop: PropTypes.func,
  renderBottomLeft: PropTypes.func,
  renderBottomRight: PropTypes.func,
};
const defaultProps = {
  renderTop: () => null,
  renderBottomLeft: () => null,
  renderBottomRight: () => null,
};

export const DEFAULT_FILTERS_WRAPPER_HEIGHT = 48;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  background-color: white;
  margin-bottom: 24px;
  border-radius: 8px;
  z-index: 99;

  ${mediaHelper.md`
    height: 168px;
  `};
`;

const StyledContainer = styled(Container)`
  && {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 24px;
    gap: 16px;
  }
`;

const FilterLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-direction: column-reverse;

  ${mediaHelper.md`
    width: auto;
    flex-direction: row;
  `};
`;

const FilterRightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  // padding: 8px 16px 8px 8px;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
  width: 100%;
`;

const Stratch = styled.div`
  flex: 1;
  padding: 0;
  position: relative;
`;

const BottomWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const FilterWrapper = ({
  renderTop,
  renderBottomLeft,
  renderBottomRight,
  ...props
}) => (
  <Wrapper {...props}>
    <StyledContainer maxWidth="lg">
      <TopWrapper>{renderTop()}</TopWrapper>
      <BottomWrapper>
        <Stratch>
          <FilterLeftWrapper>{renderBottomLeft()}</FilterLeftWrapper>
        </Stratch>
        {renderBottomRight() ? (
          <FilterRightWrapper>{renderBottomRight()}</FilterRightWrapper>
        ) : null}
      </BottomWrapper>
    </StyledContainer>
  </Wrapper>
);

FilterWrapper.propTypes = propTypes;
FilterWrapper.defaultProps = defaultProps;

export default FilterWrapper;
